export const convertTotalAmountToVND = (amount:string | number) => {
  let fee: any = Number(amount);
  fee = fee.toLocaleString("en-US");
  return `${fee} VND`;
};
export const convertTotalAmount = (amount:string | number) => {
  let fee: any = Number(amount);
  fee = fee.toLocaleString("en-US");
  return `${fee}`;
};
